import {CommonMessages} from '../common.messages';

export const PanelAccountsEditUsersMessages = {
    GetAssignedUsersFailed: {
        key: 'GetAssignedUsersFailed',
        message: 'Error while communication with the server. Unable to get assigned users to current account.'
    },
    ...CommonMessages
};
